import { CALL_QUEUE_ADD, CALL_QUEUE_REMOVE } from '../actions/types';
import { CALL_QUEUE_MAX_AGE, CALL_QUEUE_STORAGE_KEY } from '../actions/CallQueueAction';

const loadItems = () => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(CALL_QUEUE_STORAGE_KEY) || '[]');
    const now = Date.now();
    const items = Array.isArray(stored)
      ? stored.filter(item => item?.refCode && item?.patCode && Number(item.receivedAt) > now - CALL_QUEUE_MAX_AGE)
        .sort((a, b) => a.receivedAt - b.receivedAt)
      : [];
    window.sessionStorage.setItem(CALL_QUEUE_STORAGE_KEY, JSON.stringify(items));
    return items;
  } catch (error) {
    return [];
  }
};

const initialState = { items: loadItems() };

export default function CallQueueReducer(state = initialState, action = { type: undefined }) {
  switch (action.type) {
    case CALL_QUEUE_ADD:
    case CALL_QUEUE_REMOVE:
      return { ...state, ...action.playload };
    default:
      return state;
  }
}
